const SalePriceIcon = ({ color = '#002861' }: { color?: string }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 3H5a2 2 0 0 0-2 2v4M19 3h4a2 2 0 0 1 2 2v4M9 25H5a2 2 0 0 1-2-2v-4M19 25h4a2 2 0 0 0 2-2v-4"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <path
      d="M17.5 10.5c-.55-.64-1.45-1-2.5-1-1.66 0-3 1-3 2.25S13.34 14 15 14s3 1 3 2.25-1.34 2.25-3 2.25c-1.05 0-1.95-.36-2.5-1M15 7.5v2M15 18.5v2"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SalePriceIcon;
